<template>
<div id="meetingPushing">
  <div class="allSearch">
    <div class="newSearch d_flex">
      <div style="width: auto;white-space: normal">
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="EmsCode" type="text" style="" v-model="postData.emsCode">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="会议名称" type="text" style="" v-model="postData.meetingName">
        </p>
        <p>
          <cander v-model="postData.startDateTime" :className="'allInput'" placeholderName="会议开始时间-开始"  class="d_i" style="vertical-align: middle"></cander>
        </p>
        <p>
          <cander v-model="postData.endDateTime" :minDate="postData.start" :className="'allInput'" placeholderName="会议结束时间-结束"  class="d_i" style="vertical-align: middle"></cander>
        </p>
        <button class="redButton" @click="getList(1)">搜索</button>
      </div>
    </div>
  </div>
  <div class="allTablePlace">
    <div>
      <table cellspacing="0" class="allTable">
        <thead>
        <tr>
          <th>EmsCode</th>
          <th>会议名称</th>
          <th>开始时间</th>
          <th>结束时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="index" v-for="(item, index) in myList">
          <td>{{item.emsCode}}</td>
          <td class="t_l">{{item.meetingName}}</td>
          <td class="NoWrap" style="max-width: 200px">{{item.startDateTime}}</td>
          <td class="NoWrap" style="max-width: 200px">{{item.endDateTime}}</td>
          <td width="10%">
            <span  @click="getDetail(item)" class="colorRed c_p">发送模板消息</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <page v-if="totalPage !== 0" v-on:on-getList="getList($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
  </div>
  <model v-if="showModel" :buttonType="0" :title="'发送模板消息'" :maxHeight="'80vh'" :minWidth="'1200px'" v-on:on-cancel="showModel = false" v-on:on-confirm="sendMeeting">
    <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
      <meetingPushModel @sendComplete="showModel = false" ref="meetModel" :meeting="meeting"></meetingPushModel>
    </div>
  </model>
</div>
</template>

<script>
import meetingPushModel from './meetingPushModel'
export default {
  name: 'meetingPushing',
  data () {
    return {
      showModel: false,
      postData: {
        emsCode: '',
        meetingName: '',
        startDateTime: '',
        endDateTime: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      messageList: [],
      totalPage: 1,
      totalCount: 0,
      page: 1,
      meeting: {},
      myList: [
      ]
    }
  },
  created () {
    this.getList(1)
  },
  methods: {
    sendMeeting () {
      this.$refs.meetModel.sendMsg()
    },
    getDetail (item) {
      this.meeting = item
      this.showModel = true
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.meetingId === '') {
        delete data['meetingId']
      }
      if (data.startDateTime === '') {
        delete data['startDateTime']
      }
      if (data.endDateTime === '') {
        delete data['endDateTime']
      }
      if (data.startDateTime) {
        data.startDateTime += ' 00:00:00'
      }
      if (data.endDateTime) {
        data.endDateTime += ' 23:59:59'
      }
      let url = this.$commonJs.returnQuery('/api/MessageManagement/GetMeetingList', data)
      this.$axiox.getList(url).then(msg => {
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    }
  },
  components: {
    'meetingPushModel': meetingPushModel
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/messageManager/meetingPushing.vue